import * as React from "react";
import { Button } from "./button";
import { EyeIcon, EyeOffIcon } from "lucide-react";
import { cn } from "@pma/utils/helpers";
import useTranslator from "@hooks/use-translator";

export interface PasswordInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {}

const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ className, ...props }, ref) => {
    const [showPassword, setShowPassword] = React.useState(false);
    const { locale } = useTranslator();

    const isHebrew = locale === "he";
    return (
      <div className={cn("relative rounded-md")}>
        <input
          type={showPassword ? "text" : "password"}
          className={cn(
            "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
            className,
          )}
          ref={ref}
          {...props}
        />

        <Button
          type="button"
          size="icon"
          variant="ghost"
          className={cn(
            "absolute  top-1/2 h-6 w-6 -translate-y-1/2 rounded-md text-black",
            isHebrew ? "left-1" : "right-1",
          )}
          onClick={() => setShowPassword((prev) => !prev)}
        >
          {showPassword ? <EyeIcon size={18} /> : <EyeOffIcon size={18} />}
        </Button>
      </div>
    );
  },
);
PasswordInput.displayName = "PasswordInput";

export { PasswordInput };
